"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSurveyBayResponses = exports.getSurveyBayForms = exports.getSurveyBayDoc = void 0;
var firebase_1 = require("firebase");
function getSurveyBayDoc() {
    return firebase_1.firestore().collection('tempest').doc('surveyBay');
}
exports.getSurveyBayDoc = getSurveyBayDoc;
function getSurveyBayForms() {
    return getSurveyBayDoc().collection('forms');
}
exports.getSurveyBayForms = getSurveyBayForms;
function getSurveyBayResponses(userUID) {
    return firebase_1.firestore()
        .collection('users')
        .doc(userUID)
        .collection('surveyBayResponses');
}
exports.getSurveyBayResponses = getSurveyBayResponses;
